import getRecordSelector from 'root/src/client/logic/api/selectors/getRecordSelector'

export default (state, props) => {
	const record = getRecordSelector(state, props)
	if (record === undefined) return ''
	const { shareUrl } = record
	return shareUrl
}
